import { render, staticRenderFns } from "./SmsSetting.vue?vue&type=template&id=7a137012&"
import script from "./SmsSetting.vue?vue&type=script&lang=js&"
export * from "./SmsSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports